/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { getRequestOptions } from '../components/GetToken'
import { AppContext } from '../context/AppContext'
import { KTSVG } from '../../_metronic/helpers'
import { Spinner } from 'react-bootstrap-v5'

function OrderWipToDoList() {
    const { bu } = useContext(AppContext);
    const [orderWipToDoList, setOrderWipToDoList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getOrderWipToDoList();
    }, []);

    const getOrderWipToDoList = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}order/wip_to_do_list/` + bu, getRequestOptions())
            .then((resp) => {
                return resp.json()
            }
            )
            .then((resp) => {
                setLoading(false);
                setOrderWipToDoList(resp.data);
            })
    }

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className='card-title'>
                        <KTSVG
                            path='/media/icons/duotune/text/txt001.svg'
                            className='svg-icon-1 svg-icon-primary'
                        />
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            Work-in-progress To DO List
                        </span>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='ml-12'>
                        {loading &&
                            <div className="d-flex justify-content-center">
                                <Spinner animation='grow' />
                                <Spinner animation='grow' />
                                <Spinner animation='grow' />
                            </div>
                        }
                        <div className="row m-5">
                            {orderWipToDoList.length > 0 && orderWipToDoList.map((item, index) => {
                                return (
                                    <table className="table table-bordered table-hover" key={index}>
                                        <thead>
                                            <tr>
                                                <th colSpan="8" className="text-left"><h2>{item.operationName}</h2></th>
                                            </tr>
                                            <tr>
                                                <th>SN</th>
                                                <th>Order No</th>
                                                <th>Schedule Date</th>
                                                <th>Production Item</th>
                                                <th>Production Qty</th>
                                                <th>Completed Qty</th>
                                                <th>Opening Qty</th>
                                                <th>Remaining Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                item.data.map((value, key) =>
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{value.productionOrderNo}</td>
                                                        <td>{value.scheduleDate}</td>
                                                        <td>{value.itemName}</td>
                                                        <td>{value.poQty}</td>
                                                        <td>{value.completedQty}</td>
                                                        <td>{value.openingQty ? value.openingQty : 0}</td>
                                                        <td>{value.remainingQty}</td>
                                                    </tr>
                                                )
                                            }

                                        </tbody>
                                    </table>
                                )
                            }
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderWipToDoList;